import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	licenseColumn,
	salesColumn,
	wasNowColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters, ownAccountsScopeRule } from '../filter-rules';

/**
 * Recently Fixed (PD-16257) — active buyers' licenses on which a confirm
 * recorded a correction: what the file showed against what the regulator shows,
 * when, and whether the system or the team did it. The list behind each number
 * on the dashboard's What Workd Did panel, which deep-links one kind at a time —
 * so the kind filter is a default, not a lock.
 */
export const recentlyFixedList: ListBuilderList = {
	id: 'compliance-recently-fixed',
	cacheTTL: 300000,
	// Tab label, deliberately short: the tabs must fit the Needs Attention
	// strip at 1440px before the More dropdown swallows them (Chris,
	// 2026-09-20). The full name is above and on the dashboard card.
	name: 'Fixed',
	type: 'default',
	active: true,
	sortOrder: 9,
	filterRules: {
		...hideOtherCardFilters([
			'licenseRecentlyFixed',
			'licenseRecentlyFixedWindow',
		]),
		licenseSalesRep: ownAccountsScopeRule,
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseRecentlyFixed: {
			defaultValue: [{ id: 'any', label: 'Any correction' }],
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		wasNowColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
